import order_link from './order_link.vue'
const OrderLink = {
    install: function (Vue) {
        Vue.component('OrderLink', order_link)
    }
}
export default OrderLink
